export default {
  // baseUrl: 'http://localhost:8080',
  baseUrl: 'https://www.audiotestkitchen.com/player',
  // basePath: '/',
  basePath: '/player/',
  // apiHost: 'http://localhost:5000'
  apiHost: 'https://atk-player-api.audiotestkitchen.com'
}
